import NumpadDownButton from './numpadDownButton';
import NumpadSubmitButton from './numpadSubmitButton';

function NumpadFooterButtons({ setIsNumpadActive }) {
  return (
    <div className='numpad-btn-block'>
      <NumpadDownButton setIsNumpadActive={setIsNumpadActive} />
      <NumpadSubmitButton setIsNumpadActive={setIsNumpadActive} />
    </div>
  );
}

export default NumpadFooterButtons;
